import { render, staticRenderFns } from "./bKashGateway.vue?vue&type=template&id=31e25a4a&scoped=true"
import script from "./bKashGateway.vue?vue&type=script&lang=js"
export * from "./bKashGateway.vue?vue&type=script&lang=js"
import style0 from "./bKashGateway.vue?vue&type=style&index=0&id=31e25a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e25a4a",
  null
  
)

export default component.exports